// Queries
import receiptLogsCalculateCost from "./ReceiptLogsCalculateCostQuery.gql";
import receiptLogs from "./ReceiptLogsQuery.gql";

export const Query = {
    receiptLogs,
    receiptLogsCalculateCost,
};
